import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/tab-navigation.css';

/**
 * PageTitle - ページタイトルコンポーネント
 *
 * @param {string} title - ページタイトル
 * @param {string} subtitle - サブタイトル（任意）
 * @param {string} icon - アイコン絵文字（任意）
 * @param {React.ReactNode} mascot - マスコットキャラクター要素（任意）
 * @param {string} backPath - 戻るボタンのリンク先（任意）
 * @param {string} backLabel - 戻るボタンのラベル（任意、デフォルト: "戻る"）
 */
const PageTitle = ({
  title,
  subtitle = null,
  icon = null,
  mascot = null,
  backPath = null,
  backLabel = '戻る'
}) => {
  const navigate = useNavigate();

  // ブラウザのタブタイトルを設定
  useEffect(() => {
    if (title) {
      document.title = `${title} - 橋本病サポート つむぎ`;
    }
    return () => {
      // クリーンアップ時にデフォルトタイトルに戻す
      document.title = '橋本病サポート つむぎ';
    };
  }, [title]);

  return (
    <>
      {backPath && (
        <div className="page-title__back-container">
          <button
            className="page-title__back-btn"
            onClick={() => navigate(backPath)}
          >
            ← {backLabel}
          </button>
        </div>
      )}
      <div className="page-title">
        <div className="page-title__content">
          {icon && <span className="page-title__icon">{icon}</span>}
          <div className="page-title__text">
            <h1 className="page-title__main">{title}</h1>
            {subtitle && <p className="page-title__sub">{subtitle}</p>}
          </div>
        </div>
        {mascot && <div className="page-title__mascot">{mascot}</div>}
      </div>
    </>
  );
};

export default PageTitle;
